// extracted by mini-css-extract-plugin
export var equalColumn = "_i3-0";